import React from 'react'
import styles from './SystemStatusItem.module.scss'
import { URL } from '../../../constants/content'
import { kFormatter } from '../../../helpers/format'

import { ReactComponent as StarSVG } from './StarSVG.svg'
import { ReactComponent as GitHubSVG } from './GitHubSVG.svg'
import { ReactComponent as DiscordSVG } from './DiscordSVG.svg'

import classNames from 'classnames'

interface SystemStatusItemProps {
  stars?: number
  isDarkMode?: boolean
  showCommunity?: boolean
  systemStatus?: {
    serviceStatus: string | null
    isLoading: boolean
    error: boolean
  }
}

function SystemStatusItem({ stars, isDarkMode, showCommunity, systemStatus }: SystemStatusItemProps) {
  const getStatusBadgeClass = () => {
    return classNames(styles.statusBadge, {
      [styles.green]: systemStatus?.serviceStatus === 'operational',
      [styles.yellow]: systemStatus?.serviceStatus === 'degraded',
      [styles.red]: systemStatus?.serviceStatus === 'downtime',
      [styles.orange]: !systemStatus?.serviceStatus || systemStatus?.error,
      [styles.darkStatusBadge]: isDarkMode,
    })
  }

  if (showCommunity) {
    return (
      <div className={classNames(styles.container, { [styles.darkContainer]: isDarkMode })}>
        <a href={URL.statusUrl} rel='noreferrer' className={getStatusBadgeClass()}>
          {systemStatus?.isLoading ? (
            <span className={styles.dots}>
              <span className={styles.loadingDot} />
              <span className={styles.loadingDot} />
              <span className={styles.loadingDot} />
            </span>
          ) : (
            <span className={styles.dot}>
              <span className={styles.outerDot} />
            </span>
          )}
          <span className={styles.text}>API Status</span>
        </a>
        <div className={classNames(styles.communityItems, { [styles.darkCommunityItems]: isDarkMode })}>
          <a href={URL.discordServerURL} className={styles.discord}>
            <div className={styles.discordPill}>
              <DiscordSVG />
              <span>Discord</span>
            </div>
          </a>
          <a href={URL.githubRepoUrl} className={styles.github}>
            <div className={styles.githubPill}>
              <GitHubSVG />
              <span>GitHub</span>
            </div>
            <span className={styles.githubStars}>
              <StarSVG className={styles.star} />
              {stars ? `${kFormatter(stars, true)}+` : '...'}
            </span>
          </a>
        </div>
      </div>
    )
  }

  return (
    <a href={URL.statusUrl} rel='noreferrer' className={getStatusBadgeClass()}>
      {systemStatus?.isLoading ? (
        <span className={styles.dots}>
          <span className={styles.loadingDot} />
          <span className={styles.loadingDot} />
          <span className={styles.loadingDot} />
        </span>
      ) : (
        <span className={styles.dot}>
          <span className={styles.outerDot} />
        </span>
      )}
      <span className={styles.text}>API Status</span>
    </a>
  )
}

export default SystemStatusItem
